import { IressSkeleton, IressStack } from '@iress-oss/ids-components';
import { InputType, Nullable, SkeletonElement, SkeletonType } from '@xplan-pension-switching/common';
import { FC, ReactElement, ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';

import '../../styles/Skeleton.css';

const renderInput = (field: SkeletonType, testId: string): Nullable<ReactElement> =>
    field === InputType.Text || field === InputType.Date || field === InputType.Select ? (
        <>
            <IressSkeleton
                mode="text"
                className="iress-skeleton--label"
                data-testid={`${testId}__label`}
                width="10rem"
            />
            <IressSkeleton mode="rect" height="2.25rem" data-testid={`${testId}__input`} />
        </>
    ) : null;

const renderTextArea = (field: SkeletonType, testId: string): Nullable<ReactElement> =>
    field === InputType.TextArea ? (
        <>
            <IressSkeleton
                mode="text"
                className="iress-skeleton--label"
                data-testid={`${testId}__label`}
                width="10rem"
            />
            <IressSkeleton mode="rect" height="8.5rem" data-testid={`${testId}__textarea`} />
        </>
    ) : null;

const renderButton = (field: SkeletonType, testId: string): Nullable<ReactElement> =>
    field === SkeletonElement.Button ? (
        <IressSkeleton mode="rect" height="2.25rem" width="10rem" data-testid={`${testId}__button`} />
    ) : null;

const renderText = (field: SkeletonType, testId: string): Nullable<ReactElement> =>
    field === SkeletonElement.Text ? <IressSkeleton mode="text" data-testid={`${testId}__text`} /> : null;

const renderHeading = (field: SkeletonType, testId: string): Nullable<ReactElement> =>
    field === SkeletonElement.Heading ? (
        <IressSkeleton height="1.75rem" width="20rem" data-testid={`${testId}__heading`} mode="rect" />
    ) : null;

export const LoadingFields: FC<{ fields: SkeletonType[]; keyModifier?: string; testId: string }> = ({
    fields,
    keyModifier = '',
    testId,
}): ReactNode => (
    <>
        {fields.map(field => (
            <IressStack gutter="sm" key={`${field}-${keyModifier}-${uuidv4()}`} data-testid={`${testId}__section`}>
                {renderInput(field, testId)}
                {renderTextArea(field, testId)}
                {renderButton(field, testId)}
                {renderText(field, testId)}
                {renderHeading(field, testId)}
            </IressStack>
        ))}
    </>
);
